<template>
  <div class="contact-page">
    <!-- Hero Section with Form -->
    <section class="hero-section">
      <div class="container">
        <div class="hero-content">
          <h1 class="page-title">Get Involved with Us</h1>
          <p class="page-subtitle">Join us at the INTERNATIONAL EDU TRAVEL</p>

          <!-- Contact Form -->
          <div class="contact-form-card">
            <form @submit.prevent="submitForm" class="contact-form">
              <!-- Row 1: First Name and Last Name -->
              <div class="form-row">
                <div class="form-group">
                  <label class="form-label">First name*</label>
                  <input
                    v-model="formData.firstName"
                    type="text"
                    class="form-input"
                    required
                  />
                </div>
                <div class="form-group">
                  <label class="form-label">Last name*</label>
                  <input
                    v-model="formData.lastName"
                    type="text"
                    class="form-input"
                    required
                  />
                </div>
              </div>

              <!-- Row 2: Job Title and Company Name -->
              <div class="form-row">
                <div class="form-group">
                  <label class="form-label">Job title*</label>
                  <input
                    v-model="formData.jobTitle"
                    type="text"
                    class="form-input"
                    required
                  />
                </div>
                <div class="form-group">
                  <label class="form-label">Company name*</label>
                  <input
                    v-model="formData.companyName"
                    type="text"
                    class="form-input"
                    required
                  />
                </div>
              </div>

              <!-- Row 3: Country/Region -->
              <div class="form-row">
                <div class="form-group full-width">
                  <label class="form-label">Country/Region</label>
                  <input
                    v-model="formData.country"
                    type="text"
                    class="form-input"
                  />
                </div>
              </div>

              <!-- Row 4: Email and Phone Number -->
              <div class="form-row">
                <div class="form-group">
                  <label class="form-label">Email*</label>
                  <input
                    v-model="formData.email"
                    type="email"
                    class="form-input"
                    required
                  />
                </div>
                <div class="form-group">
                  <label class="form-label">Phone number*</label>
                  <div class="phone-input-wrapper">
                    <select v-model="formData.countryCode" class="country-select">
                      <option value="+976">Mongolia (Mon</option>
                      <option value="+1">US</option>
                      <option value="+44">UK</option>
                      <option value="+971">UAE</option>
                    </select>
                    <input
                      v-model="formData.phone"
                      type="tel"
                      class="form-input phone-input"
                      placeholder="+976"
                      required
                    />
                  </div>
                </div>
              </div>

              <!-- How Should We Contact You -->
              <div class="form-group full-width">
                <label class="form-label">How Should We Contact You?*</label>
                <select v-model="formData.contactMethod" class="form-select" required>
                  <option value="">Please Select</option>
                  <option value="email">Email</option>
                  <option value="phone">Phone</option>
                  <option value="both">Both</option>
                </select>
              </div>

              <!-- I am interested in -->
              <div class="form-group full-width">
                <label class="form-label">I am interested in*</label>
                <div class="checkbox-group">
                  <label class="checkbox-label">
                    <input type="checkbox" v-model="formData.interests" value="sponsorship" />
                    <span>Sponsorship and Exhibition</span>
                  </label>
                  <label class="checkbox-label">
                    <input type="checkbox" v-model="formData.interests" value="delegate" />
                    <span>Delegate Pass</span>
                  </label>
                  <label class="checkbox-label">
                    <input type="checkbox" v-model="formData.interests" value="speaking" />
                    <span>Speaking</span>
                  </label>
                  <label class="checkbox-label">
                    <input type="checkbox" v-model="formData.interests" value="media" />
                    <span>Media Partnership</span>
                  </label>
                </div>
              </div>

              <!-- Event Selection -->
              <div class="form-group full-width">
                <label class="form-label">Select the event(s) you're interested in</label>
                <div class="checkbox-group">
                  <label class="checkbox-label">
                    <input type="checkbox" v-model="formData.events" value="abu-dhabi" />
                    <span>INTERNATIONAL EDU TRAVEL - Abu Dhabi (8-9 Dec 2025)</span>
                  </label>
                  <label class="checkbox-label">
                    <input type="checkbox" v-model="formData.events" value="riyadh" />
                    <span>INTERNATIONAL EDU TRAVEL - Riyadh (9 - 10 Feb 2026)</span>
                  </label>
                </div>
              </div>

              <!-- Newsletter Consent -->
              <div class="form-group full-width">
                <label class="checkbox-label consent">
                  <input type="checkbox" v-model="formData.newsletter" />
                  <span>I provide my consent to INTERNATIONAL EDU TRAVEL and would like to receive the latest updates via email with information related to their events and activities. I would also like to subscribe to the newsletters from INTERNATIONAL EDU TRAVEL powered by Times of AI.*</span>
                </label>
              </div>

              <!-- Terms Agreement -->
              <div class="form-group full-width">
                <label class="checkbox-label consent">
                  <input type="checkbox" v-model="formData.terms" required />
                  <span>I AGREE TO THE <a href="#" class="link">GENERAL TERMS</a> AND CONDITIONS AND <a href="#" class="link">PRIVACY POLICY</a> OF INTERNATIONAL EDU TRAVEL*</span>
                </label>
              </div>

              <!-- Submit Button -->
              <button type="submit" class="submit-btn">Submit</button>
            </form>
          </div>
        </div>
      </div>
    </section>

    <!-- Contact Options Section -->
    <section class="contact-options-section">
      <div class="container">
        <div class="contact-cards">
          <!-- Chat with Sales -->
          <div class="contact-card">
            <h3 class="card-title">Chat with Sales</h3>
            <p class="card-description">
              We will help you find the right packages and pricing for your business.
            </p>
            <button class="card-btn" @click="contactSales">Contact Sales</button>
          </div>

          <!-- Book a Meeting -->
          <div class="contact-card">
            <h3 class="card-title">Book a Meeting</h3>
            <p class="card-description">
              Schedule a 30-minute discovery call with our CSRs to Get tailor-made plans that suit your unique needs.
            </p>
            <button class="card-btn" @click="scheduleCall">Schedule Call</button>
          </div>

          <!-- Call Us -->
          <div class="contact-card">
            <h3 class="card-title">Call Us</h3>
            <p class="card-description">
              Skip the line. Get in touch with our team directly.
            </p>
            <button class="card-btn card-btn-phone">+971 4 239 1320</button>
          </div>
        </div>
      </div>
    </section>

    <!-- Additional Contact Section -->
    <section class="additional-contact-section">
      <div class="container">
        <div class="contact-info-cards">
          <!-- Speaker Enquiry -->
          <div class="info-card">
            <h4 class="info-title">Speaker enquiry</h4>
            <p class="info-text">Interested in speaking at our event? Mail us or apply</p>
            <a href="mailto:speaker@edtravel.mn" class="info-email">speaker@edtravel.mn</a>
            <button class="info-btn">Apply Now</button>
          </div>

          <!-- Media Accreditation -->
          <div class="info-card">
            <h4 class="info-title">Media accreditation</h4>
            <p class="info-text">We'd love for you to be a part of INTERNATIONAL EDU TRAVEL</p>
            <a href="mailto:media@edtravel.mn" class="info-email">media@edtravel.mn</a>
            <button class="info-btn">Submit</button>
          </div>

          <!-- Community Partner -->
          <div class="info-card">
            <h4 class="info-title">Community partner</h4>
            <p class="info-text">Step inside the INTERNATIONAL EDU TRAVEL Community.</p>
            <a href="mailto:community@edtravel.mn" class="info-email">community@edtravel.mn</a>
            <button class="info-btn">Apply now</button>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ContactPage',
  data() {
    return {
      formData: {
        firstName: '',
        lastName: '',
        jobTitle: '',
        companyName: '',
        country: '',
        email: '',
        countryCode: '+976',
        phone: '',
        contactMethod: '',
        interests: [],
        events: [],
        newsletter: false,
        terms: false
      }
    }
  },
  methods: {
    submitForm() {
      console.log('Form submitted:', this.formData)
      // Add form submission logic here
    },
    contactSales() {
      // Add contact sales logic
      console.log('Contact Sales clicked')
    },
    scheduleCall() {
      // Add schedule call logic
      console.log('Schedule Call clicked')
    }
  }
}
</script>

<style scoped>
/* Hero Section */
.hero-section {
  background: linear-gradient(135deg, #6B2DD8 0%, #8B5CF6 50%, #A78BFA 100%);
  background-image: url('https://www.globalaishow.com/wp-content/uploads/2024/08/bg-1.svg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  padding: 100px 20px 100px;
  position: relative;
}

.container {
  max-width: 750px;
  margin: 0 auto;
}

.hero-content {
  text-align: center;
}

.page-title {
  font-size: 42px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 8px 0;
  line-height: 1.2;
  letter-spacing: -0.5px;
}

.page-subtitle {
  font-size: 16px;
  color: #ffffff;
  margin: 0 0 45px 0;
  font-weight: 400;
  opacity: 0.95;
}

/* Contact Form Card */
.contact-form-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 50px 45px 45px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.12), 0 5px 20px rgba(0, 0, 0, 0.08);
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full-width {
  grid-column: 1 / -1;
}

.form-label {
  font-size: 13px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
}

.form-input {
  padding: 13px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 15px;
  font-family: inherit;
  background: #fafafa;
  width: 100%;
  box-sizing: border-box;
  transition: all 0.2s ease;
}

.form-input:hover {
  border-color: #d0d0d0;
  background: #ffffff;
}

.form-input:focus {
  outline: none;
  border-color: #6320EE;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(99, 32, 238, 0.1);
}

.form-select {
  padding: 13px 16px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 15px;
  font-family: inherit;
  background: #fafafa;
  width: 100%;
  box-sizing: border-box;
  cursor: pointer;
  transition: all 0.2s ease;
}

.form-select:hover {
  border-color: #d0d0d0;
  background: #ffffff;
}

.form-select:focus {
  outline: none;
  border-color: #6320EE;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(99, 32, 238, 0.1);
}

.phone-input-wrapper {
  display: flex;
  gap: 8px;
  width: 100%;
}

.country-select {
  padding: 13px 14px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 15px;
  background: #fafafa;
  cursor: pointer;
  min-width: 140px;
  font-weight: 400;
  transition: all 0.2s ease;
}

.country-select:hover {
  border-color: #d0d0d0;
  background: #ffffff;
}

.country-select:focus {
  outline: none;
  border-color: #6320EE;
  background: #ffffff;
  box-shadow: 0 0 0 3px rgba(99, 32, 238, 0.1);
}

.phone-input {
  flex: 1;
}

/* Checkbox Group */
.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.checkbox-label {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  font-size: 14px;
  color: #333;
  cursor: pointer;
  line-height: 1.5;
}

.checkbox-label input[type="checkbox"] {
  margin-top: 2px;
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #6320EE;
}

.checkbox-label.consent {
  font-size: 13px;
  color: #666;
  line-height: 1.6;
}

.link {
  color: #6320EE;
  text-decoration: underline;
}

/* Submit Button */
.submit-btn {
  width: 100%;
  padding: 16px;
  background: linear-gradient(135deg, #6320EE, #7c3aed);
  border: none;
  color: #FFFFFF;
  font-size: 15px;
  line-height: 1;
  font-family: sans-serif;
  border-radius: 8px;
  font-weight: 700;
  cursor: pointer;
  margin-top: 12px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 14px rgba(99, 32, 238, 0.3);
}

.submit-btn:hover {
  background: linear-gradient(135deg, #7c3aed, #8b4fed);
  box-shadow: 0 6px 20px rgba(99, 32, 238, 0.4);
  transform: translateY(-1px);
}

/* Contact Options Section */
.contact-options-section {
  padding: 90px 20px;
  background: #f7f8fa;
}

.contact-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

.contact-card {
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 12px;
  padding: 45px 35px;
  text-align: center;
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 340px;
}

.contact-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 12px 35px rgba(0, 0, 0, 0.1);
  border-color: #d0d0d0;
}

.card-title {
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 16px 0;
}

.card-description {
  font-size: 14px;
  color: #666;
  line-height: 1.7;
  margin: 0 0 28px 0;
  flex-grow: 1;
}

.card-btn {
  padding: 13px 32px;
  background: linear-gradient(135deg, #6320EE, #7c3aed);
  border: none;
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 14px rgba(99, 32, 238, 0.25);
}

.card-btn:hover {
  background: linear-gradient(135deg, #7c3aed, #8b4fed);
  box-shadow: 0 6px 20px rgba(99, 32, 238, 0.35);
  transform: translateY(-2px);
}

.card-btn-phone {
  font-size: 16px;
  letter-spacing: 0.3px;
}

/* Additional Contact Section */
.additional-contact-section {
  padding: 90px 20px;
  background: #ffffff;
}

.contact-info-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 50px;
  max-width: 1200px;
  margin: 0 auto;
}

.info-card {
  text-align: left;
  padding: 25px 0;
  border-bottom: 2px solid #e8e8e8;
  transition: all 0.3s ease;
}

.info-card:hover {
  border-bottom-color: #6320EE;
}

.info-title {
  font-size: 20px;
  font-weight: 700;
  color: #1a1a1a;
  margin: 0 0 14px 0;
}

.info-text {
  font-size: 14px;
  color: #666;
  margin: 0 0 18px 0;
  line-height: 1.6;
}

.info-email {
  display: block;
  font-size: 15px;
  color: #FF7F6B;
  text-decoration: none;
  margin-bottom: 22px;
  font-weight: 500;
  transition: color 0.3s ease;
}

.info-email:hover {
  color: #FF6B57;
  text-decoration: underline;
}

.info-btn {
  padding: 11px 26px;
  background: transparent;
  border: 2px solid #1a1a1a;
  color: #1a1a1a;
  font-size: 14px;
  font-weight: 600;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.info-btn:hover {
  background: #1a1a1a;
  color: #ffffff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Responsive */
@media (max-width: 960px) {
  .form-row {
    grid-template-columns: 1fr;
  }

  .contact-cards {
    grid-template-columns: 1fr;
    gap: 25px;
  }

  .contact-info-cards {
    grid-template-columns: 1fr;
    gap: 35px;
  }

  .page-title {
    font-size: 36px;
  }

  .contact-form-card {
    padding: 40px 30px 35px;
  }

  .hero-section {
    padding: 80px 20px 80px;
  }
}

@media (max-width: 600px) {
  .hero-section {
    padding: 70px 15px 70px;
  }

  .page-title {
    font-size: 30px;
  }

  .page-subtitle {
    font-size: 15px;
  }

  .contact-form-card {
    padding: 35px 22px 30px;
  }

  .contact-card {
    padding: 35px 25px;
  }
}
</style>
